module.exports = __webpack_public_path__ + "7615c00637410af8bdb474c24a4655d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-more.png
// module id = 604
// module chunks = 0